// Shared bearer-token header helper for pages that fetch() directly instead of
// going through utils/api.ts's apiFetch wrapper. Tries the accountant JWT
// portal token first (persisted in localStorage), then falls back to the
// Clerk session token via the registered getter (see utils/api.ts
// getAuthToken / setAuthTokenGetter, wired up in App.tsx) — this covers both
// in-house staff and attorneys, who now authenticate via Clerk only (the
// legacy attorney_token JWT machinery was retired; the backend rejects it).
import { getAuthToken } from '../utils/api';

export async function getAuthHeaders(): Promise<Record<string, string>> {
  let token: string | null = null;
  try {
    token = localStorage.getItem('accountant_token');
  } catch {
    token = null;
  }
  if (!token) {
    token = await getAuthToken();
  }
  return token ? { Authorization: `Bearer ${token}` } : {};
}
